import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import Select from "react-select";
import trasportApi from "../../api/trasportApi";
import { Link } from "react-router-dom";
import { ROUTES } from "../../constants/WebRouting";
import PubSub from "pubsub-js";
import { validationMessages } from "../../utils/messages";
import InfoPill from "../InfoPill";
import { BrowserView } from "react-device-detect";
import Main from "../layout/Main";

// Define initial errors i.e. required field and their message
const initialErrors = {
  product_qty: { message: validationMessages.quantity.required },
  selling_price: { message: validationMessages.salePrice.required },
  //  contact_id: {message : validationMessages.customer.required},
};

export default function Inventory() {
  const [showStockOutModal, setShowStockOutModal] = useState(false);
  const [stockOutData, setStockOutData] = useState({});
  // validation state
  const [validated, setValidated] = useState(false);
  //errors state
  const [errors, setErrors] = useState(initialErrors);
  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);

  const [headers, setHeaders] = useState([
    {
      title: "Product Name",
      prop: "product_name",
      cell: (row) => (
        <Link to={`${ROUTES.PRODUCT.LIST}/${row.product_id}`} state={row}>
          {" "}
          {row.product_name}{" "}
        </Link>
      ),
      isFilterable: true,
    },
    {
      title: "Category Name",
      prop: "category_name",
      isFilterable: true,
    },
    {
      title: "Stock In",
      prop: "stock_in",
      isFilterable: true,
    },

    {
      title: "Stock Out",
      prop: "stock_out",
      isFilterable: true,
    },
    {
      title: "Stock Available",
      prop: "stock_available",
      isFilterable: true,
    },
    //comment by shahir hussain 30-05-2025
    // {
    //   title: "Action",
    //   prop: "product_id",
    //   cell: (row) => (
    //     <Button
    //       className="btn-edit"
    //       variant="success"
    //       onClick={() => {
    //         setShowStockOutModal(true);
    //         const {
    //           product_id,
    //           product_name,

    //           category_name : category_name,
    //           category_id : category_id,
    //           stock_available,
    //         } = row;
    //         setStockOutData({
    //           product_id,
    //           product_name,

    //           category_id,
    //           category_name,
    //           stock_available,
    //         });
    //       }}
    //     >
    //       <i className="fa-solid fa-edit" aria-hidden="true"></i>
    //     </Button>
    //   ),
    // },
  ]);
  const [body, setBody] = useState(null);

  const [products, setProducts] = useState([]);
  // accounts
  const [accounts, setAccounts] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [optionCategory, setOptionCategory] = useState();
  const [selectedCategory, setSelectedCategory] = useState();

  async function fetchProducts() {
    const fetchedProducts = await trasportApi.fetchProducts();
    Array.isArray(fetchedProducts) && setProducts([...fetchedProducts]);
  }

  async function fetchData() {
    const fetchedData = await trasportApi.fetchInventory();
    console.log("inventory == ", fetchedData)
    Array.isArray(fetchedData) && setBody(fetchedData);
  }

  async function init() {
    fetchProducts();
    fetchData();
    fetchContacts();
    fetchCategories();
    fetchAccounts();

  }

  useEffect(() => {
    init();
  }, []);

  async function fetchCategories() {
    const fetchCategories = await trasportApi.fetchAllCategory();

    if (fetchCategories) {
      let categoryOptions = fetchCategories.map((item) => ({
        value: item.id,
        label: item.name,
        contact: item,
      }));

      setOptionCategory(categoryOptions);
    } else {
      setOptionCategory([]);
    }

  }



  async function fetchContacts() {
    // const fetchedContacts = await trasportApi.fetchContactsWithCustomers();

    // Array.isArray(fetchedContacts) &&
    //   setContacts(
    //     fetchedContacts?.map((fetchedContact) => ({
    //       id: fetchedContact?.id,
    //       name: `${fetchedContact?.firstname || ""} ${fetchedContact?.lastname || ""
    //         }`,
    //       contactData: fetchedContact,
    //     }))
    //   );
  }

  async function fetchAccounts() {
    // const fetchAccounts = await trasportApi.fetchAccounts();
    // console.log("fetchAccounts", fetchAccounts);
    // Array.isArray(fetchAccounts) &&
    //   setAccounts(
    //     fetchAccounts?.map((fetchAccount) => ({
    //       id: fetchAccount?.id,
    //       name: `${fetchAccount?.name || ""}`,
    //     }))
    //   );
  }

  const handleShowStockOutModalHide = () => {
    setShowStockOutModal(false);
  };

  // onChange Handler
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name == "product_qty") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.quantity.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "selling_price") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.salePrice.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "contact_id") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.customer.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    setValidated(true);
    setStockOutData((prev) => ({ ...prev, [name]: value }));
  };

  // field validators
  const checkRequiredFields = () => {
    let isError = false;

    if (stockOutData?.product_qty) {
      if (stockOutData?.product_qty == "") {
        setErrors((prev) => ({
          ...prev,
          product_qty: { message: validationMessages.quantity.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["product_qty"];
          return { ...prev };
        });
      }
    }
    if (stockOutData?.selling_price) {
      if (stockOutData?.selling_price == "") {
        setErrors((prev) => ({
          ...prev,
          selling_price: { message: validationMessages.salePrice.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["selling_price"];
          return { ...prev };
        });
      }
    }

    if (!stockOutData?.title) {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Required",
        message: "Please Select Type",
      });
      isError = true;
    }

    return isError;
  };

  // onSubmit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }

    if (Object?.keys(errors)?.length != 0) {
      setValidated(true);
      return;
    }

    if ((!stockOutData?.product_qty) || stockOutData?.product_qty == 0) {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Invalid",
        message: "Invalid stock quantity",
      });
      return;
    }
    if ((!stockOutData?.selling_price) || stockOutData?.selling_price == 0) {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Invalid",
        message: "Invalid Sale Price",
      });
      return;
    }



    if (
      !stockOutData.product_qty ||
      Number(stockOutData.product_qty) > Number(stockOutData.stock_available)
    ) {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Invalid",
        message: "Stock not available",
      });
      return;
    }

    const record = { ...stockOutData };

    console.log("RECORD", record);

    delete record.branch_name;
    delete record.product_name;
    delete record.stock_available;
    delete record.category_name;
    delete record.contact_name;
    delete record.accountname;

    // //========= Logic to perform Create or Edit ======
    if (record.id) {
      console.log('Updated');
      const result = await trasportApi.saveSalesOrder(record);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Update",
          message: "Record updated successfully",
        });
        handleShowStockOutModalHide();
        setStockOutData(null);
        init();
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Update Error",
          message: result?.errors,
        });
      }
    } else {
      console.log('Created');
      const resultPurchaseOrder = await trasportApi.createSalesOrder(record);
      if (resultPurchaseOrder?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record created",
          message: "Record created successfully",
        });
        handleShowStockOutModalHide();
        setStockOutData(null);
        init();
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Save Error",
          message: resultPurchaseOrder?.errors,
        });
      }
    }
  };


  return (
    <>
      <Main>
        <Container fluid>
          <Row>
            <Container>
              <DatatableWrapper
                headers={headers}
                body={body || []}
                paginationOptionsProps={{
                  initialState: {
                    rowsPerPage: 15,
                    options: [5, 10, 15, 20],
                  },
                }}
              >
                <Row className="align-items-end">
                  <Col md={4}>
                    <Filter
                      classes={{
                        inputGroup: "",
                        input: "",
                        clearButton: "btn-custom",
                      }}
                    />
                  </Col>
                  <Col
                    // md={1}
                    xs={12}
                    sm={6}
                    lg={5}
                    className="d-flex flex-col justify-content-start align-items-center"
                  >
                    <PaginationOptions labels={{ beforeSelect: " " }} />
                    <BrowserView className="mx-5 mt-4">
                      <InfoPill
                        left="Total"
                        right={body?.length}
                        rightClasses="bg-custom text-white border-white fw-bold"
                        leftClasses="bg-white text-custom fw-bold " />
                    </BrowserView>
                  </Col>
                  {/* <Col className="py-1">
                <BrowserView>
                  <div className="d-flex py-1 px-2 ">
                    <InfoPill
                      left="Total"
                      right={body?.length}
                      rightClasses="bg-custom text-white border-white fw-bold"
                      leftClasses="bg-white text-custom fw-bold "
                    />
                  </div>
                </BrowserView>
              </Col> */}
                </Row>
                <Table striped className="shadow rounded sm my-4 data-table" responsive={true}>
                  <TableHeader/>
                  {body && Array.isArray(body) ? (
                    <TableBody />
                  ) : (
                    <tbody className="">
                      <tr>
                        {/* <td colSpan={100} align="center"> */}
                        <td colSpan={100} style={{ padding: "7px 7px", textAlign: "left", color: "#333" }}>
                          No results to be shown.
                          {/* <div>
                        <Spinner />
                      </div> */}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
                <Pagination
                  classes={{
                    buttonGroup: "",
                    button: "bg-custom border-white",
                  }}
                />
              </DatatableWrapper>
            </Container>
          </Row>
          {showStockOutModal && (
            <Modal
              size="xl"
              show={showStockOutModal}
              onHide={handleShowStockOutModalHide}
            >
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <ModalHeader closeButton>
                  <ModalTitle>Stock Out View</ModalTitle>
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Col lg={6} >
                      <Form.Group >
                        <Form.Label
                          className="form-view-label "
                          htmlFor="formBasicFirstName"
                        >
                          Category Name
                        </Form.Label>
                        <Select
                          isDisabled
                          placeholder="Select Category"
                          //onChange={handleCategory}
                          options={optionCategory}
                          //  value={selectedCategory}
                          onChange={(e) => {
                            handleChange({
                              target: { name: "category_id", value: e.value },
                            });
                            handleChange({
                              target: { name: "category_name", value: e.label },
                            });
                          }}
                          value={
                            stockOutData?.category_id
                              ? {
                                value: stockOutData?.category_id || "",
                                label: stockOutData?.category_name || "",
                              }
                              : ""
                          }
                        ></Select>
                        <Form.Control.Feedback type="invalid">
                          Please provide Category Name.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <FormLabel
                          className="form-view-label"
                          htmlFor="formBasicFirstName"
                        >
                          Product
                        </FormLabel>
                        <Select
                          placeholder="Select your product"
                          options={[stockOutData]?.map((product) => ({
                            value: product?.product_id,
                            label: product?.product_name,
                          }))}
                          isDisabled
                          value={
                            stockOutData?.product_id
                              ? {
                                value: stockOutData?.product_id || "",
                                label: stockOutData?.product_name || "",
                              }
                              : ""
                          }
                        ></Select>
                      </FormGroup>
                    </Col>
                    <Col lg={6} className="my-2">
                      <Form.Group >
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicTitle"
                        >
                          Type
                        </Form.Label>
                        <Form.Select
                          required
                          placeholder="Select Type"
                          aria-label="Select Contact Type"
                          name="title"
                          value={stockOutData?.title || ""}
                          onChange={handleChange}
                        >
                          <option value="">---Select---</option>
                          <option value="Company">Comapany</option>
                          <option value="Customer">Customer</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    {stockOutData?.title === "Company" &&
                      <Col lg={6} className="my-2">
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicState"
                          >
                            Company Name
                          </Form.Label>
                          <Select
                            placeholder="Select your Account"
                            options={accounts?.map((account) => ({
                              value: account?.id,
                              label: account?.name,
                            }))}
                            onChange={(e) => {
                              handleChange({
                                target: { name: "accountid", value: e.value },
                              });
                              handleChange({
                                target: { name: "accountname", value: e.label },
                              });
                            }}
                            value={
                              stockOutData?.accountid
                                ? {
                                  value: stockOutData?.accountid || "",
                                  label: stockOutData?.accountname || "",
                                }
                                : ""
                            }
                          ></Select>
                        </Form.Group>
                      </Col>
                    }
                    {stockOutData?.title === "Customer" &&
                      <Col lg={6} className="my-2">
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicState"
                          >
                            Customer Name
                          </Form.Label>
                          <Select
                            placeholder="Select Your Customer"
                            options={contacts?.map((contact) => ({
                              value: contact?.id,
                              label: contact?.name,
                            }))}
                            onChange={(e) => {
                              handleChange({
                                target: { name: "contact_id", value: e.value },
                              });
                              handleChange({
                                target: { name: "contact_name", value: e.label },
                              });
                            }}
                            value={
                              stockOutData?.contact_id
                                ? {
                                  value: stockOutData?.contact_id || "",
                                  label: stockOutData?.contact_name || "",
                                }
                                : ""
                            }
                          ></Select>
                          <Form.Control.Feedback type="invalid">
                            {errors?.contact_id?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    }
                    <Col md={6} className="my-1">
                      <FormGroup>
                        <FormLabel
                          className="form-view-label"
                          htmlFor="formBasicFirstName"
                        >
                          Quantity
                        </FormLabel>
                        <FormControl
                          required
                          placeholder="Enter quantity"
                          type="number"
                          onKeyDownCapture={(e) =>
                            ["e", "E", "+", "-"].includes(e.key) &&
                            e.preventDefault()
                          }
                          name={`product_qty`}
                          value={stockOutData?.product_qty || ""}
                          onChange={handleChange}
                          min={1}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.product_qty?.message}
                        </Form.Control.Feedback>
                      </FormGroup>
                    </Col>

                    <Col md={6} className="my-1">
                      <FormGroup>
                        <FormLabel
                          className="form-view-label"
                          htmlFor="formBasicFirstName"
                        >
                          Sale Price
                        </FormLabel>
                        <FormControl
                          required
                          placeholder="Enter Sale Price"
                          type="number"
                          onKeyDownCapture={(e) =>
                            ["e", "E", "+", "-"].includes(e.key) &&
                            e.preventDefault()
                          }
                          name={`selling_price`}
                          value={stockOutData?.selling_price || ""}
                          onChange={handleChange}
                          min={1}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.selling_price?.message}
                        </Form.Control.Feedback>
                      </FormGroup>
                    </Col>

                    <Col md={6} className="my-1">
                      <FormGroup>
                        <FormLabel
                          className="form-view-label"
                          htmlFor="formBasicFirstName"
                        >
                          Sale Date
                        </FormLabel>
                        <FormControl

                          placeholder="Enter Sale Price"
                          type="date"
                          name={`selling_date`}
                          value={stockOutData?.selling_date}
                          onChange={handleChange}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </ModalBody>
                <ModalFooter>
                  <Button className="btn-delete" variant="light" onClick={handleShowStockOutModalHide}>
                    Close
                  </Button>
                  <Button className="btn-edit" variant="success" type="submit">
                    Save
                  </Button>
                </ModalFooter>
              </Form>
            </Modal>
          )}
        </Container>
      </Main>
    </>

  );
}


